import { Sparkles } from 'lucide-react';
import { AIInsightsCards } from '../AIInsightsCards';

interface IntelligenceDashboardProps {
  isLoading?: boolean;
}

export const IntelligenceDashboard = ({ isLoading }: IntelligenceDashboardProps) => {
  return (
    <div className='tw:space-y-6'>
      <div>
        <div className='tw:flex tw:items-center tw:gap-2 tw:mb-1'>
          <Sparkles className='tw:size-5 tw:text-violet-500' />
          <h5 className='tw:text-base tw:font-semibold tw:mb-0'>Emissions Intelligence</h5>
        </div>
        <p className='tw:text-sm tw:text-muted-foreground'>
          AI-powered analysis and recommendations to help reduce your carbon footprint.
        </p>
      </div>
      <AIInsightsCards isLoading={isLoading} />
    </div>
  );
};
